/**
 * adminApi.js — Cliente HTTP para el panel admin
 * Agrega ?_token= a cada request automáticamente
 */
import axios from "axios";

export const ADMIN_API = `${process.env.REACT_APP_BACKEND_URL}/admin/api`;

const adminApi = axios.create({ baseURL: ADMIN_API });

// Interceptor: agrega ?_token= a cada request
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    const sep = config.url.includes("?") ? "&" : "?";
    config.url = `${config.url}${sep}_token=${token}`;
  }
  return config;
});

// Interceptor: si recibe 401, redirige al login
adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export default adminApi;
